module.exports = __webpack_public_path__ + "img/image7.467c44df.png";